import React from "react";
import "../Services/Services.css";

const HowItWorkPreview = ({ previewService, setShowPreviewHowItWork }) => {
    const service = previewService;

    if (!service) return null;

    const cards = service.cards?.[0] || {};

    const cardList = [
        { no: "1", title: cards.card1, desc: cards.description1 },
        { no: "2", title: cards.card2, desc: cards.description2 },
        { no: "3", title: cards.card3, desc: cards.description3 },
        { no: "4", title: cards.card4, desc: cards.description4 },
    ];

    return (
        <div className="how-overlay" onClick={() => setShowPreviewHowItWork(false)}>
            <div className="how-modal" onClick={(e) => e.stopPropagation()}>

                <button className="how-close" onClick={() => setShowPreviewHowItWork(false)}>
                    ✕
                </button>
             
                <div className="how-wrapper">
                    {/* LEFT TEXT */}
                    <div className="how-left">

                        <p className="how-subtitle">HOW IT WORKS</p>

                        <h1 className="how-main-title">{service.heading}</h1>

                        {cardList.map((item, index) => (
                            <div key={index} className="how-step">

                                {/* TITLE ROW */}
                                <div className="how-step-header">
                                    <span className="how-step-no">{item.no}</span>

                                    <h3
                                        className="how-step-title"
                                        dangerouslySetInnerHTML={{ __html: item.title }}
                                    />
                                </div>

                                {/* DESCRIPTION */}
                                <p
                                    className="how-step-desc"
                                    dangerouslySetInnerHTML={{ __html: item.desc }}
                                />

                                {index < 3 && <div className="how-divider"></div>}
                            </div>
                        ))}


                    </div>

                    {/* RIGHT IMAGE */}
                    <div className="how-right">
                        <img src={service.image} alt="" className="how-image" />
                    </div>
                </div>

            </div>
        </div>
    );
};

export default HowItWorkPreview;
